import React, { useState, useEffect } from 'react';

interface InputFormProps {
  onSubmit: (
    desc: string,
    material: string,
    use: string,
    state: string,
  ) => void;
  isStreaming: boolean;
  initialValue?: string;
  isInteractionDisabled?: boolean;
}

const InputForm: React.FC<InputFormProps> = ({
  onSubmit,
  isStreaming,
  initialValue,
  isInteractionDisabled = false,
}) => {
  const [productDesc, setProductDesc] = useState<string>(initialValue || '');
  const [material, setMaterial] = useState<string>('');
  const [intendedUse, setIntendedUse] = useState<string>('');
  const [physicalState, setPhysicalState] = useState<string>('');

  const handleEnterPress = (e: any) => {
    if (isInteractionDisabled) {
      return;
    }
    if (e.key === 'Enter' || e.which === 13) {
      onSubmit(productDesc, material, intendedUse, physicalState);
    }
  };

  useEffect(() => {
    if (initialValue !== undefined) {
      setProductDesc(initialValue);
    }
  }, [initialValue]);

  return (
    <>
      <div className='classify'>
        <div className='classify-header'>Product Description </div>
        <div className='classify-cont'>
          <div className='classify-cont-sec'>
            <div className='classify-cont-sec-div'>
              <textarea
                id='classify-input-id'
                placeholder='Enter your product description or relevant keywords. Include details like material, use, or any other information that can help improve classification accuracy.'
                className='classify-cont-sec-input'
                rows={1}
                value={productDesc}
                onChange={(e) => setProductDesc(e.target.value)}
                onKeyUp={handleEnterPress}
                onInput={(e) => {
                  const target = e.target as HTMLTextAreaElement;
                  target.style.height = 'auto';
                  target.style.height = `${target.scrollHeight}px`;
                }}
              />
            </div>
          </div>

          {/* --- PHASE 2: OPTIONAL FIELDS --- */}
          <div
            style={{
              marginTop: '15px',
              borderTop: '1px solid var(--border-color)',
              paddingTop: '15px',
              width: '100%',
            }}
          >
            <div className='classify-header' style={{ opacity: 0.8 }}>
              Optional Details (Improves Accuracy)
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                gap: '10px',
                marginTop: '10px',
              }}
            >
              <div style={{ width: 'inherit' }}>
                <label
                  style={{
                    fontSize: '12px',
                    display: 'block',
                    marginBottom: '4px',
                    fontWeight: '600',
                    fontFamily: 'Inter',
                  }}
                >
                  Material
                </label>
                <input
                  className='classify-cont-sec-input'
                  style={{ padding: '8px' }}
                  placeholder='e.g. Steel, Cotton'
                  value={material}
                  onKeyUp={handleEnterPress}
                  onChange={(e) => setMaterial(e.target.value)}
                />
              </div>
              <div style={{ width: 'inherit' }}>
                <label
                  style={{
                    fontSize: '12px',
                    display: 'block',
                    marginBottom: '4px',
                    fontWeight: '600',
                    fontFamily: 'Inter',
                  }}
                >
                  Intended Use
                </label>
                <input
                  className='classify-cont-sec-input'
                  style={{ padding: '8px' }}
                  placeholder='e.g. Medical, Filtration'
                  value={intendedUse}
                  onKeyUp={handleEnterPress}
                  onChange={(e) => setIntendedUse(e.target.value)}
                />
              </div>
              <div style={{ width: 'inherit' }}>
                <label
                  style={{
                    fontSize: '12px',
                    display: 'block',
                    marginBottom: '4px',
                    fontWeight: '600',
                    fontFamily: 'Inter',
                  }}
                >
                  Physical State
                </label>
                <input
                  className='classify-cont-sec-input'
                  style={{ padding: '8px' }}
                  placeholder='e.g. Part, Finished, Set'
                  value={physicalState}
                  onKeyUp={handleEnterPress}
                  onChange={(e) => setPhysicalState(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        <div className='classify-footer'>
          <div
            className='classify-footer-btn'
            onClick={() =>
              onSubmit(productDesc, material, intendedUse, physicalState)
            }
            aria-disabled={isStreaming}
          >
            <div className='classify-footer-btn-div' style={{ color: '#fff' }}>
              Submit
            </div>
          </div>
          <div className='classify-footer-txt'>or press Enter</div>
        </div>
      </div>
    </>
  );
};

export default InputForm;
